import { useNavigate } from 'react-router'
import Card from '../../components/common/Card'
import PageMeta from '../../components/common/PageMeta'
import DefaultTable from '../../components/tables/DefaultTable/DefaultTable'
import Badge from '../../components/ui/badge/Badge'
import { useCreate } from '../../context/CreateRegisterContext'
import { ProfessionalDataType, useProfessional } from '../../context/ProfessionalContext'
import ProfessionalForm from './ProfessionalForm'

export default function ProfessionalPage() {
    const { professionals } = useProfessional()
    const navigate = useNavigate()
    const { openProfessional, setOpenProfessional } = useCreate()

    const rows = professionals.map(professional => ({
        ...professional,
        profile: professional.admin ? <Badge color='primary'>Administrador</Badge> : <Badge color='light'>Profissional</Badge>
    }))

    const columns = [
        { key: 'id', label: '#' },
        { key: 'name', label: 'Nome' },
        { key: 'email', label: 'E-mail' },
        { key: 'profile', label: 'Perfil' }
    ]

    const handleClick = (row: ProfessionalDataType) => navigate(`/profissional/${row.id}`)

    return (
        <>
            <PageMeta title='Profissionais | CRM' description='Lista todos os profissionais' />
            <div className='space-y-6'>
                <Card>
                    <DefaultTable
                        columns={columns}
                        rows={rows}
                        rowsPerPage={20}
                        handleClick={handleClick}
                        handleCreate={() => setOpenProfessional(true)}
                    />
                </Card>
            </div>
            <ProfessionalForm
                type='create'
                open={openProfessional}
                handleClose={() => setOpenProfessional(false)}
            />
        </>
    )
}
